import { render } from "./Accept.vue?vue&type=template&id=36fdbea6"
import script from "./Accept.vue?vue&type=script&lang=js"
export * from "./Accept.vue?vue&type=script&lang=js"

import "./Accept.vue?vue&type=style&index=0&id=36fdbea6&lang=less"
script.render = render

export default script